import type { ContentNugget } from '@backrs_ui/common-ui';

import { toAgentContextNugget } from '@backrs_ui/grow-ui/src/agentContext/toAgentContextNugget';
import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type { PriorityTask } from '@backrs_ui/grow-ui/src/redux/priorities/priorities.types';

/** @param nuggets - real nuggets only; entries are resolved by id downstream. */
export const useAgentContext = (task?: PriorityTask | null, nuggets: ContentNugget[] = []) => {
  useRegisterAgentContext(
    task
      ? {
          kind: 'entity',
          description: 'The playbook task the user is viewing',
          data: {
            id: task.id,
            title: task.title,
            description: task.description,
            priority: task.priority,
            status_code: task.status_code,
            type_code: task.type_code,
            due_date: task.due_date,
            content_url: task.content_url,
            playlist_id: task.playlist_id,
            tags: task.tags?.map((tag) => tag.title),
          },
        }
      : null,
  );

  useRegisterAgentContext(
    nuggets.length > 0
      ? {
          kind: 'nuggetList',
          description: 'Content attached to the task being viewed',
          nuggets: nuggets.map(toAgentContextNugget),
        }
      : null,
  );
};
